/**
 * Human-readable text for the actionable Stripe error codes, ported from the Ember UI
 * (`app/utils/errors/formatters/stripe.ts`). Not every Stripe error code is mapped — only the
 * ones that are actionable by the customer. See https://stripe.com/docs/error-codes.
 */
export const STRIPE_ERROR_CODES: Record<string, string> = {
  card_declined: 'Your payment failed because your card was declined. Contact your card issuer.',
  balance_insufficient:
    'Your payment failed because your card has insufficient funds. Add a valid payment method to keep using your account.',
  incorrect_number:
    'Your payment failed because your card number is incorrect. Add a valid payment method to keep using your account.',
  expired_card:
    'Your payment failed because your card has expired. Add a valid payment method to keep using your account.',
  authentication_required:
    'Your payment method requires 3DSecure verification. Check for a notification from your card issuer.',
};

/**
 * Maps a Stripe error code to actionable text, falling back to a generic message for unmapped or
 * missing codes. Ports the Ember `stripeFormatter`.
 */
export function stripeFormatter(errorCode?: string | null, fallbackText?: string): string {
  const fallback = fallbackText ?? 'Your payment failed. Add a valid payment method to keep using your account.';
  if (errorCode == null) {
    return fallback;
  }
  return STRIPE_ERROR_CODES[errorCode] ?? fallback;
}
